module.exports = __webpack_public_path__ + "media/images/default/shared/header/main-md-8c5d72ca9c3e011c7a746fca5261faad.jpg";